function removeLoadingEl() {
	const loadingOverlay = document.querySelector('.loading-overlay');
	if (typeof loadingOverlay != 'undefined' && loadingOverlay != null) {
		loadingOverlay.remove();
	}
}

document.addEventListener('readystatechange', (event) => {
	if (event.target.readyState === 'complete') {
		removeLoadingEl();
		document.querySelectorAll('.auto-hide').forEach((autoHide) => {
			autoHide.style.display = 'block';
		});
	}
});
